import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=348dd2f7&scoped=true&"
import script from "./PackageSelector.vue?vue&type=script&lang=js&"
export * from "./PackageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PackageSelector.vue?vue&type=style&index=0&id=348dd2f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348dd2f7",
  null
  
)

export default component.exports